{
  "intervalSeconds": 10,
  "waves": [
    { "ships": [{ "ship": "interceptor", "profile": "rookie" }] },
    {
      "ships": [
        { "ship": "interceptor", "profile": "rookie" },
        { "ship": "interceptor", "profile": "rookie" }
      ]
    },
    {
      "ships": [
        { "ship": "interceptor", "profile": "rookie" },
        { "ship": "interceptor", "profile": "rookie" },
        { "ship": "interceptor", "profile": "veteran" }
      ]
    },
    {
      "ships": [
        { "ship": "gunship", "profile": "veteran" },
        { "ship": "interceptor", "profile": "veteran" },
        { "ship": "interceptor", "profile": "veteran" }
      ]
    }
  ],
  "repeat": { "waves": [3, 4], "escalate": 1, "cap": "ace" },
  "spawn": { "distance": [2000, 2600], "coneDeg": 60 }
}
